var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"form-step-detail\"><div vueinit props=\"{ parameter: vm.parameter, userInput: vm.userInput, sitzungPk: vm.sitzungPk, top: vm.top, emitEventAngular: vm.emitEventAngular  }\"><vue-sitzungsantraege-list-in-tageordnungspunkt v-bind:parameter=\"propsAngular.parameter\" v-bind:user-input=\"propsAngular.userInput\" v-bind:sitzung-pk=\"propsAngular.sitzungPk\" v-bind:top=\"propsAngular.top\" v-bind:emit-event-angular=\"propsAngular.emitEventAngular\"></vue-sitzungsantraege-list-in-tageordnungspunkt></div></div>");;return buf.join("");
}